import { Navigate, Outlet } from 'react-router-dom'
import { useAuth } from '@/lib/contexts/AuthContext'

export default function ProtectedRoute() {
  const { token, isLoading } = useAuth()

  if (isLoading) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="text-lg">Loading...</div>
      </div>
    )
  }

  if (!token) {
    return <Navigate to="/sign-in" replace />
  }

  return <Outlet />
}